<!-- src/js/widgets/manager-requests/components/ReplyForm.vue -->
<template>
  <div class="manager-requests__reply-form">
    <Textarea
      v-model="message"
      rows="5"
      :autoResize="true"
      placeholder="Введите ваш ответ..."
      :disabled="loading"
      style="width: 100%"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import Textarea from 'primevue/textarea';

const props = defineProps<{
  loading: boolean;
  modelValue: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const message = ref(props.modelValue);

// Синхронизация с родителем
watch(
  () => props.modelValue,
  (newVal) => {
    message.value = newVal;
  },
);

watch(message, (newVal) => {
  emit('update:modelValue', newVal);
});

defineExpose({
  clearMessage: () => {
    message.value = '';
  },
});
</script>
